import { NewsService } from '@/services/news.service';
import { useQuery } from '@tanstack/react-query';

export function useNews() {
  const { data: news = [], isLoading } = useQuery({
    queryKey: ['active-news'],
    queryFn: NewsService.getActiveNews,
    staleTime: 1000 * 60,
  });

  return { news, isLoading };
}
